var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAtsConnect(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 10,
    viewBox: "0 0 25 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "connect-solid",
    transform: "translate(-3.667 -15.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12943",
    "data-name": "Path 12943",
    d: "M14.667,16h-2.28a5.051,5.051,0,0,0-4.968,4.166H2.667v1.666H7.411A5.027,5.027,0,0,0,12.387,26h2.28Z",
    transform: "translate(1 0)",
    fill: "#7d7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12944",
    "data-name": "Path 12944",
    d: "M32.717,20.165A5.05,5.05,0,0,0,27.733,16h-2.4V26h2.4a5.027,5.027,0,0,0,4.976-4.166h4.624V20.165Z",
    transform: "translate(-8.666 0)",
    fill: "#7d7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAtsConnect);
export default __webpack_public_path__ + "static/media/ATSConnect.3ca4380b9b8aea78a360781412fedd2b.svg";
export { ForwardRef as ReactComponent };